export default __webpack_public_path__ + "static/media/093-diagonal-arrow-15.c0bd7023.png";